import React from 'react';
import { Modal } from 'antd';
import EditableCell from '../../common/tableCell/TableCell';
import $ from '../../../common/AjaxRequest';
import TableC from '../../basicElement/TableC';
import API_URL from '../../../common/url';
import '../style/list.less';

class Crf extends React.Component {
    state = {
        columns: [],
        dataSource: [],
        loading: false,
        scrollX: false,
        requiredMap: new Map(),
	}

    show = (record = {}) => {
		const params = { ...JSON.parse(JSON.stringify(record)) };
		const { typeName, controllers, tableColumns } = this.props;
		if (typeName == 'Type_Pre_Filter') {
			Object.keys(params).forEach(key => {
				if (typeof params[key] == 'object') {
					const suffix = key.slice(-2);
					const code = key.slice(0, key.length -2);
					const column = tableColumns.find(column => column.moduleDefineCode == code);
					const name = column ? column.moduleDefineName : '';
					if (name) {
						if (name != '预筛号' && name != '患者来源' && name != '其他来源描述') {
							if (name == '录入者') {
								params[key]['value'] = sessionStorage.userName;
							} else {
								params[key]['value'] = '';
								const array = controllers.filter(controll => controll.controller == code);
								if (array.length) {
									array.forEach(item => {
										const controlled = item.controlled;
										params[controlled + suffix]['editable'] = 0;
									});
								}
							}
						}
					} 
				}
			});
		} else if (typeName == 'Type_Filter') {
			Object.keys(params).forEach(key => {
				if (typeof params[key] == 'object') {
					const code = key.slice(0, key.length -2);
					const column = tableColumns.find(column => column.moduleDefineCode == code);
					const name = column ? column.moduleDefineName : '';
					if (name) {
						if (name != '筛选编号' && name != '知情同意时间') {
							if (name == '录入者') {
								params[key]['value'] = sessionStorage.userName;
							} else {
								params[key]['value'] = '';
							}
						}
					}
				}
			});
		}
        this.setState({
            visible: true,
            dataSource: [{ ...params }]
        }, () => {
			const newColumns = JSON.parse(JSON.stringify(tableColumns));
			newColumns.pop()
            const { columns } = this.convertColumns(newColumns);
            this.setState({ columns });
        });
    }

    hide = () => {
        this.setState({
			visible: false,
			dataSource: [],
		});
    }

	getSaveParam = (rowDataOriginal) => {
		const rowData = JSON.parse(JSON.stringify(rowDataOriginal));
		const paramsObj = {
			newParams: '',
			postObj: {}
		};
		let indicatorCount = -1;
		const indicatorRowCount = {};
		const rowIndexObj = {};
		let newParams = ``;
		newParams += `?`;
		const saveRowNum = rowData.rowNum;
		for (const key in rowData) {
			if (typeof (rowData[key]) === "object") {
				if (key === (rowData[key].moduleDefineCode + '_' + rowData[key].rowNum)) {
					const { moduleDefineCode } = rowData[key];
					const rowCount = indicatorRowCount[moduleDefineCode];
					if (rowData[key].value) {
						rowData[key]["operationType"] = 'INSERT';
					}
					if (rowData[key].operationType) {
						if (rowCount >= 0) {
							indicatorRowCount[rowData[key].moduleDefineCode] = indicatorRowCount[rowData[key].moduleDefineCode] + 1;
						} else {
							indicatorRowCount[rowData[key].moduleDefineCode] = 0;
							indicatorCount++;
							rowIndexObj[rowData[key].moduleDefineCode] = indicatorCount;
						}
						for (const keySec in rowData[key]) {
							if (keySec == "rowNum") {
								paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicators[${indicatorRowCount[rowData[key].moduleDefineCode]}].${keySec}`] = saveRowNum + 1;
							} else if (keySec != "realRowNum") {
								paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicators[${indicatorRowCount[rowData[key].moduleDefineCode]}].${keySec}`] = rowData[key][keySec] ? rowData[key][keySec] : '';
							}
						}
						paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicatorCode`] = rowData[key].moduleDefineCode;
					}
				}
			} else {
				newParams += '&' + key + '=' + rowData[key];
			}
		}
		paramsObj.newParams = newParams;
		return paramsObj;
	}

	rowSave = (record, index, flag) => {
		const { typeName, visitGroupingId } = this.props;
		const { requiredMap } = this.state;
		for (let [key, value] of requiredMap) {
			if (!record[key]) {
				if (requiredMap.get(key) == "患者编号") {
					if (typeName == 'Type_Visit') {
						Modal.error({ title: `请选择您录入的${requiredMap.get(key)}` });
					} else {
						Modal.error({ title: `请输入您录入的${requiredMap.get(key)}` });
					}
					return;
				} else {
					Modal.error({ title: `请输入${requiredMap.get(key)}` });
					return;
				}
			} else if (record[key]) {
				if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
					if (record[key].editable !== 0) {
						if (record[key]['value'] == "" || record[key]['value'] == undefined) {
							Modal.error({ title: `请输入${requiredMap.get(key)}` });
							return;
						}
					}
				} else {
					if (record[key]['value'] == "" || record[key]['value'] == undefined) {
						Modal.error({ title: `请输入${requiredMap.get(key)}` });
						return;
					}
				}
			}
		}
		const paramsObj = this.getSaveParam(record);
		this.setState({ loading: true });
		const options = {
			url: `${API_URL.execute.save}${paramsObj.newParams}`,
			data: {
				...paramsObj.postObj,
                typeName,
				key: '1new5efk',
				visitGroupingId,
				isCheck: flag !== '' ? 1 : flag,
			},
			method: 'post',
			dataType: 'json',
			doneResult: () => {
				this.setState({
					visible: false,
					loading: false,
				}, () => {
                    this.props.loadData();
                })
			},
			errorResult: () => {
				this.setState({ loading: false });
			},
			failResult: () => {
				this.setState({ loading: false });
			}
		};
		$.sendRequest(options);
	}

	convertColumns = (tableColumns) => {
		const columns = [];
		const { dataSource } = this.state;
		const { typeName } = this.props;
		const dataEmpty = dataSource.length === 0 ? true : false;
		const requiredMap = new Map();

		const newTableColums = [];
		tableColumns.forEach(column => {
			const { rowNum, isShow, moduleDefineCode, moduleDefineName, moduleDefineIsRequired } = column;
			if (typeName == 'Type_Filter' || typeName == 'Type_Visit') {
				if (isShow) {
					newTableColums.push(column);
				}
			} else {
				newTableColums.push(column);
			}
			if (moduleDefineName !== '操作' || moduleDefineName !== '录入者') {
				if (moduleDefineIsRequired == "1") {
					requiredMap.set(moduleDefineCode + "_" + rowNum, moduleDefineName);
				} else if (moduleDefineIsRequired == "0" && (moduleDefineName == 'SAE结束时间' || moduleDefineName == '与试验药物是否相关' || moduleDefineName == 'SAE结局')) {
					requiredMap.set(moduleDefineCode + "_" + rowNum, moduleDefineName);
				}
			}
		});

		const isNeedWidth = newTableColums.length > 8;
		let scrollX = isNeedWidth ? (newTableColums.length - 1) * 150 : 960;
		newTableColums.map((tableColumn, columnIndex) => {
			let title = tableColumn.moduleDefineName || '',
				type = tableColumn.criteriaDataType,
				webType = tableColumn.projectDefineWebType,
				dataIndex = tableColumn.moduleDefineCode == "op" ? tableColumn.moduleDefineCode : tableColumn.moduleDefineCode + "_" + tableColumn.rowNum,
				criteriaDefineId = tableColumn.criteriaDefineId,
				canAddComment = tableColumn.canAddComment,
				column = {
					visitTypeName: tableColumn.visitTypeName,
					visitTypeNameShow: tableColumn.visitTypeNameShow,
				},
				config = {
					isEdit: true,
					comment: {
						iscomment: false,
					},
					colorClass: "normal",
					type: {
						type: type,
						webType: webType,
						moduleDefineConstraintValue: tableColumn.moduleDefineConstraintValue,
						formatValue: tableColumn.formatValue
					},
					...tableColumn
				};
			if (webType) {
				column.dataIndex = dataIndex;
			}
			column.type = type;
			column.webType = webType;
			if (isNeedWidth) {
				column.width = 150;
			} else {
				column.width = 960 / (newTableColums.length - 1);
			}
			if (tableColumn.fixed == "left" && isNeedWidth) {
				if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') {
					column.fixed = 'left';
				}
			}
			if (tableColumn.canAddComment == 1) {
				config.comment.iscomment = true;
			}
			if (title == '患者编号') {
				column.title = <p>患者编号</p>
			} else {
				column.title = (<div style={{ display: "inline-block", whiteSpace: 'initial' }}>{title.split("\r\n").map((i, index) => {
					return <p>{i}</p>;
				})}</div>);
			}
			if (dataIndex !== "op" && title != '录入者' && canAddComment != 1) {
				column.render = (text, record, index) => {
                    config.isEdit = true;
                    let isEdit = true;
                    if (record) {
                        if (record.editable == 0) {
                            isEdit = false;
                        } else {
                            const { typeName } = this.props;
                            if (typeName == 'Type_Pre_Filter' && (title == '预筛号' || title == '患者来源' || title == '其他来源描述')) {
                                isEdit = false;
                            } else if (typeName == 'Type_Filter' && (title == '筛选编号' || title == '知情同意时间' || title == '是否第一个受试者入组')) {
								isEdit = false;
							}
                        }
                    }
                    if (text) {
                        if (text.editable == 0) {
                            isEdit = false;
                        }
                    }
                    let special = false;
                    return (
                        !dataEmpty &&
                        <EditableCell
                            cellValue={text}
                            onChange={this.onCellChange(index, dataIndex, criteriaDefineId, special, record, tableColumn)}
                            onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
							typeName={typeName}
							config={config}
                            isEdit={isEdit}
                            visitGroup={this.props.visitGroup}
                            cur={this.props.cur}
                        />
                    )
                }

				columns.push(column);
			}
		});
		this.setState({ requiredMap });

		let visitTypeName = [];
		const parentColumn = [];
		columns.map((column) => {
			if (column.visitTypeName) {
				if (!visitTypeName.includes(column.visitTypeName)) {
					visitTypeName.push(column.visitTypeName);
				}
			}
		})
		visitTypeName.map((typeName) => {
			const typeColumn = {
				title: typeName,
			}
			const columnChildren = [];
			columns.map((column) => {
				if (column.visitTypeName == typeName) {
					columnChildren.push(column);
				}
			})
			typeColumn.children = columnChildren;
			parentColumn.push(typeColumn);
		})
		columns.map((column, colindex) => {
			if (visitTypeName.includes(column.visitTypeName)) {
				parentColumn.map((parcol, index) => {
					if (parcol.title == column.visitTypeName) {
						columns[colindex] = parentColumn[index];
						visitTypeName = visitTypeName.filter(value => value !== column.visitTypeName)
					}
				})
			} else {
				if (column.visitTypeName) {
					delete columns[colindex];
				}
			}
		});
		this.setState({ scrollX });
		return { columns };
	}

	getFatherIndex = (record) => {
		const dataSource = this.state.dataSource;
		let dataIndex;
		dataSource.map((father, fatherIndex) => {
			if (father['children']) {
				father['children'].map((child, childIndex) => {
					if (child.key == record.key) {
						dataIndex = fatherIndex;
					}
				})
			}
		})
		return dataIndex;
	}

	onCellChange = (index, key, criteriaDefineId, special, record, tableColumn) => {
		return (value, type) => {
			const dataSource = [...this.state.dataSource];
			
			if (type == 'reRender') {
				this.setState({ dataSource });
				return;
			}
            
            const { controllers, tableColumns, typeName } = this.props;

			if ((record && record.child) !== 1 || record.child == undefined) {
				if (!dataSource[index][key] || (dataSource[index][key] && !dataSource[index][key]['moduleDefineCode'])) {
					this.initValue(dataSource[index], key, tableColumn);
					if (type !== "comment") {
						if (value !== "") {
							dataSource[index][key]['value'] = value; 
						}
					}
				}
				// console.log(key, value);
				this.loopController(typeName, dataSource[index], key, value, tableColumns, controllers);
				dataSource[index][key][type] = value;
				dataSource[index]["isSave"] = true;
			} else {
				const dataIndex = this.getFatherIndex(record);
				if (dataSource[dataIndex] && dataSource[dataIndex]['children']) {
					if (!dataSource[dataIndex]['children'][index][key] || (dataSource[dataIndex]['children'][index][key] && !dataSource[dataIndex]['children'][index][key]['moduleDefineCode'])) {
						this.initValue(dataSource[dataIndex]['children'][index], key, tableColumn);
						if (type !== "comment") {
							if (value !== "") {
								dataSource[dataIndex]['children'][index][key]['value'] = value;
							}
						}
					}
				}
				if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
					const suffix = key.slice(-2);
					const code = key.slice(0, key.length -2);
					controllers.forEach(item => {
						if (item.controller == code) {
							if (item.oper == 'EQ') {
								const controlledKey = item.controlled + suffix;
								if (dataSource[dataIndex]['children'][index][controlledKey]) {
									dataSource[dataIndex]['children'][index][controlledKey]['editable'] = item.value == value ? 1 : 0;
								} else {
									const controllColumn = tableColumns.find(column => column.moduleDefineCode == item.controlled) || {};
									this.initValue(dataSource[dataIndex]['children'][index], controlledKey, controllColumn);
									dataSource[dataIndex]['children'][index][controlledKey]['editable'] = item.value == value ? 1 : 0;
								}
							}
						}
					});
				}
				this.loopController(typeName, dataSource[dataIndex]['children'][index], key, value, tableColumns, controllers);
				dataSource[dataIndex]['children'][index][key][type] = value;
				dataSource[dataIndex]['children'][index]["isSave"] = true;
			}
			this.setState({ dataSource });
		};
    }
    
    initValue = (obj, code, tableColumn) => {
		const { typeName } = this.props;
		obj[code] = {
			comment: "",
			criteriaDefineId: tableColumn.criteriaDefineId,
			value: "",
			editable: 1,
			moduleDefineCode: tableColumn.moduleDefineCode,
			rowNum: tableColumn.rowNum,
		};
		if (typeName != 'Type_Filter') {
			obj[code]['realRowNum'] = obj['rowNum'];
		}
	}

	loopController = (typeName, obj, key, value, tableColumns, controllers) => {
		if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
			const suffix = key.slice(-2);
			const code = key.slice(0, key.length -2);
			// 查询是否是控制列表中
			controllers.forEach(item => {
				if (item.controller == code) {
					const controlledKey = item.controlled + suffix;
					if (item.oper == 'EQ') {
						//	被控制方存在
						if (obj[controlledKey] && obj[controlledKey].moduleDefineCode) {
							let editable;
							if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
								editable = (!!value && obj[key]['editable'] != 0) ? 1 : 0;
							} else {
								editable = (item.value == value && obj[key]['editable'] != 0) ? 1 : 0;
							}
							obj[controlledKey]['editable'] = editable;
							if (!editable) {
								obj[controlledKey]['value'] = '';
							} else {
								if (typeName == 'Type_Filter') {
									if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
										const moduleDefine = tableColumns.find(column => column.moduleDefineName == '筛选编号') || {};
										const { moduleDefineCode } = moduleDefine;
										obj[controlledKey]['value'] = obj[moduleDefineCode + suffix]['value'];
									} else if (item.controllerName == '是否筛选成功' && (item.controlledName == '是否第一个受试者入组' || item.controlledName == '是否最后一个受试者入组')) {
										obj[controlledKey]['value'] = '否';
									}
								}
							}
						} else {
							// 不存在
							const controllColumn = tableColumns.find(column => column.moduleDefineCode == item.controlled) || {};
							this.initValue(obj, controlledKey, controllColumn);
							let editable;
							if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
								editable = (!!value && obj[key]['editable'] != 0) ? 1 : 0;
							} else {
								editable = (item.value == value && obj[key]['editable'] != 0) ? 1 : 0;
							}
							obj[controlledKey]['editable'] = editable;
							if (!editable) {
								obj[controlledKey]['value'] = '';
							} else {
								if (typeName == 'Type_Filter') {
									if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
										const moduleDefine = tableColumns.find(column => column.moduleDefineName == '筛选编号') || {};
										const { moduleDefineCode } = moduleDefine;
										obj[controlledKey]['value'] = obj[moduleDefineCode + suffix]['value'];
									} else if (item.controllerName == '是否筛选成功' && (item.controlledName == '是否第一个受试者入组' || item.controlledName == '是否最后一个受试者入组')) {
										obj[controlledKey]['value'] = '否';
									}
								}
							}
						}
					}
					// 查询被控制方是否在控制列表中作为控制方存在
					const newValue = obj[controlledKey]['value'] || '';
					this.loopController(typeName, obj, controlledKey, newValue, tableColumns, controllers);
				}
			});
		}
	}

	onPatientCodeChange = (index, key, criteriaDefineId, record) => {
		return (value, type) => {
			const { dataSource } = this.state;
			if (record && record.child !== 1) {
				const rowObj = dataSource[index];
				if (rowObj.key && rowObj.key.endsWith("new5efk")) {
					dataSource[index].patientUserId = value.patientId;
				}
				dataSource[index].newPatientUserId = value.patientId;

			} else {
				const dataIndex = this.getFatherIndex(record);
				if (rowObj.key && rowObj.key.endsWith("new5efk")) {
					dataSource[dataIndex]['children'][index].patientUserId = value.patientId;
				}
				dataSource[dataIndex]['children'][index].newPatientUserId = dataSource[dataIndex]['children'][index].patientUserId;
			}
			this.setState({ dataSource });
		};
	}

    render() {
        const { typeName, canEditByInvStatus } = this.props;
        const { visible, columns, loading, dataSource } = this.state;
        return (
            <Modal
                title={`再次${typeName == 'Type_Filter' ? '筛选' : '预筛'}`}
                visible={visible}
                onCancel={this.hide}
                onOk={() => canEditByInvStatus(() => this.rowSave(dataSource[0], 1))}
                className="preview-modal"
				wrapClassName="vertical-center-modal"
				confirmLoading={loading}
                width="1000px"
            >
                <div className="execute-crf" style={{ padding: 20 }}>
					<TableC
						columns={columns}
						data={dataSource}
						rowKey="key"
						className='table-cell-row crf-table crfAgain'
					/>
                </div>
            </Modal>
        );
    }
}

export default Crf;



// WEBPACK FOOTER //
// ./src/components/execute/crfAgain/index.js